/* global module, require */
const crel = require('./createElement'),
	empty = require('./emptyElement');

function PlannerSteps(parent) {
	var me = this;

	me.parent = parent;
	me.element = crel({ _parent: parent.element, className: 'planner-steps' });
	me.numbers = true;
	me.clear();
}

PlannerSteps.prototype.clear = function() {
	if (this.current && this.current.deactivate) this.current.deactivate();

	this.steps = [];
	this.latest = null;
	this.current = null;
	empty(this.element);

	return this;
};

PlannerSteps.prototype.add = function(step) {
	var me = this;
	step.previous = me.latest;
	step.index = me.steps.length;
	me.steps.push(step);

	if (me.latest) me.latest.next = step;
	me.latest = step;

	step.button = crel({
		_tag: 'button',
		_parent: me.element,
		className: 'step',
		innerText: me.numbers ? `${me.steps.length}. ` : '',
		onclick: () => me.goto(step.index),
	});

	step.name = crel({
		_tag: 'span',
		_parent: step.button,
		className: 'name',
		innerText: step.name,
	});

	return me;
};

PlannerSteps.prototype.activate = function(step) {
	var me = this;

	if (me.current && me.current.deactivate) me.current.deactivate();

	me.index = me.steps.indexOf(step);
	me.steps.forEach((s, i) => {
		s.button.classList.remove('active');
		if (i === me.index) s.button.classList.add('active');

		s.button.classList.remove('done');
		if (i < me.index) s.button.classList.add('done');
	});

	step.activate();
	me.parent.activated(step);
	me.current = step;
	return me;
};

PlannerSteps.prototype.limitSkips = function(index) {
	for (var i = 0; i < index; i++) {
		const step = this.steps[i];
		if (!step.complete()) return i;
	}

	return index;
};

PlannerSteps.prototype.goto = function(requested) {
	var index = requested;

	if (index < 0) index = 0;
	if (index >= this.steps.length) index = this.steps.length - 1;

	index = this.limitSkips(index);

	return index === this.index ? this : this.activate(this.steps[index]);
};

PlannerSteps.prototype.previous = function() {
	return this.goto(this.index - 1);
};

PlannerSteps.prototype.next = function() {
	return this.goto(this.index + 1);
};

module.exports = PlannerSteps;
